import { Button } from '@mui/material';
import React, { useCallback } from 'react';

import Admin_CopyApplicationCycleModal from './CopyApplicationCycleModal';

const Admin_ApplicationCycleButtons: React.FC = () => {
  const [openCopyApplicationCyclesModal, setOpenCopyApplicationCyclesModal] = React.useState(false);

  const handleCreateNewApplicationCycles = useCallback(() => {
    setOpenCopyApplicationCyclesModal(true);
  }, []);

  return (
    <>
      <Button
        key='copy-app-cycles'
        sx={{ marginRight: '10px' }}
        variant='secondary'
        onClick={handleCreateNewApplicationCycles}
      >
        Create New Application Cycles
      </Button>
      {openCopyApplicationCyclesModal && (
        <Admin_CopyApplicationCycleModal onClose={() => setOpenCopyApplicationCyclesModal(false)} />
      )}
    </>
  );
};
export default Admin_ApplicationCycleButtons;
